// https://developer.atlassian.com/platform/ufo/ufo-core/intro-and-basics/taxonomy/

// Deprecated pattern. Please refer to ufo-events.ts to create new UFO events
export const UfoEventName = {
    /**
     * Land Step — User can view signup pages
     * - Tome SLOs: https://tome.prod.atl-paas.net/capability/4cba7cce-f259-4957-b071-297d12f2a2e2
     **/
    ENTER_SIGNUP_FLOW_SLO_SUCCEEDED: "enter-signup-flow.slo-succeeded",
    ENTER_SIGNUP_FLOW_SLO_FAILED: "enter-signup-flow.slo-failed",

    /**
     * Land Step — New user can create an account
     * - Tome SLOs: https://tome.prod.atl-paas.net/capability/2b3257ff-3fcb-4bab-ad4a-21addc51da91
     **/
    BXPUI_ACCOUNT_CREATION_SLO: "bxpui.account-creation.slo",
    BXPKIT_ACCOUNT_CREATION_SLO: "bxpkit.account-creation.slo",

    /**
     * Land Step — User can submit to start site and/or product activation
     * - Tome SLOs: https://tome.prod.atl-paas.net/capability/5eb87129-93bf-4299-bb87-647274daab95
     **/
    // Default submit captured across bxpui and bxpkit
    DEFAULT_SIGNUP_SUBMIT_SLO_SUCCEEDED: "default-signup-submit.slo-succeeded",
    DEFAULT_SIGNUP_SUBMIT_SLO_FAILED: "default-signup-submit.slo-failed",
    BXPUI_SIGNUP_SUBMIT_SLO_SUCCEEDED: "bxpui-signup-submit.slo-succeeded",
    BXPUI_SIGNUP_SUBMIT_SLO_FAILED: "bxpui-signup-submit.slo-failed",
    BXPKIT_SIGNUP_SUBMIT_SLO_SUCCEEDED:
        "bxpkit-signup-form-submit.slo-succeeded",
    BXPKIT_SIGNUP_SUBMIT_SLO_FAILED: "bxpkit-signup-form-submit.slo-failed",

    /**
     * Land Step — User can land into product from signup
     * - Tome SLOs: https://tome.prod.atl-paas.net/capability/94be6943-f4c3-4f5e-9ec3-370dc65bb3af
     **/
    BXPUI_CONFIRMATION_PAGE_STATUS_POLLING_SLO:
        "bxpui.confirmation-page-status-polling.slo",

    BXPUI_REDIRECT_TO_PRODUCT_FROM_CONFIRMATION_PAGE_SLO:
        "bxpui.redirect-to-product-from-confirmation-page.slo",

    /**
     * Experiment  — Skip Site Name (Confluence)
     * - Tome SLOs: https://tome.prod.atl-paas.net/capability/52b1f859-d43d-4c5a-8466-26da34b97655\
     * - Statsig Setup: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/bxpsu-2243_skip_site_name_experiment
     **/
    BXPSU_2243_SKIP_SITE_NOT_ENROLLED: "bxpsu-2243-skip-site.not-enrolled",
    BXPSU_2243_SKIP_SITE_TREATMENT_ENROLLED:
        "bxpsu-2243-skip-site.treatment.enrolled",
    BXPSU_2243_SKIP_SITE_TREATMENT_SLO_SUCCEEDED:
        "bxpsu-2243-skip-site.treatment.slo-succeeded-v2",
    BXPSU_2243_SKIP_SITE_TREATMENT_SLO_FAILED:
        "bxpsu-2243-skip-site.treatment.slo-failed-v2",
    BXPSU_2243_SKIP_SITE_CONTROL_ENROLLED:
        "bxpsu-2243-skip-site.control.enrolled",
    BXPSU_2243_SKIP_SITE_CONTROL_SLO_SUCCEEDED:
        "bxpsu-2243-skip-site.control.slo-succeeded",
    BXPSU_2243_SKIP_SITE_CONTROL_SLO_FAILED:
        "bxpsu-2243-skip-site.control.slo-failed",

    /**
     * Experiment  — Skip Site Name (JSW)
     * - Tome SLOs: TBD
     * - Statsig Setup: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/bxpsu_2770_jsw_skip_site_name/setup
     **/
    BXPSU_2770_JSW_SKIP_SITE_NOT_ENROLLED:
        "bxpsu-2770-jsw-skip-site.not-enrolled",
    BXPSU_2770_JSW_SKIP_SITE_TREATMENT_ENROLLED:
        "bxpsu-2770-jsw-skip-site.treatment.enrolled",
    BXPSU_2770_JSW_SKIP_SITE_TREATMENT_SLO_SUCCEEDED:
        "bxpsu-2770-jsw-skip-site.treatment.slo-succeeded-v2",
    BXPSU_2770_JSW_SKIP_SITE_TREATMENT_SLO_FAILED:
        "bxpsu-2770-jsw-skip-site.treatment.slo-failed-v2",
    BXPSU_2770_JSW_SKIP_SITE_CONTROL_ENROLLED:
        "bxpsu-2770-jsw-skip-site.control.enrolled",
    BXPSU_2770_JSW_SKIP_SITE_CONTROL_SLO_SUCCEEDED:
        "bxpsu-2770-jsw-skip-site.control.slo-succeeded",
    BXPSU_2770_JSW_SKIP_SITE_CONTROL_SLO_FAILED:
        "bxpsu-2770-jsw-skip-site.control.slo-failed",

    /* Events */
    ACTIVATE_PRODUCT_API_SUCCESS: "activate-product-api.success",
    ACTIVATE_PRODUCT_API_ERROR: "activate-product-api.error",
    SITE_ACTIVATE_DIRECT_API_SUCCESS: "site-activate-direct-api.success",
    SITE_ACTIVATE_DIRECT_API_ERROR: "site-activate-direct-api.error",
    SITE_ACTIVATE_DIRECT_API_RETRY_GUARD:
        "site-activate-direct-api.retry-guard",
    SITE_ACTIVATE_DIRECT_API_BLOCKER: "site-activate-direct-api.blocker",
    SITE_ACTIVATE_DIRECT_API_TIMEOUT: "site-activate-direct-api.timeout",
    SITE_ACTIVATE_DIRECT_API_SHADOW_IT_REDIRECT:
        "site-activate-direct-api.shadow-it-redirect",

    /**
     * Experiment - Confluence set up over provisioning
     * - statsig setup: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/cfind-1054_confluence_set_up_over_provisioning/setup
     */
    CONFLUENCE_SETUP_OVER_SITE_PROVISIONING_INVITE_LINK_FETCH_ERROR:
        "cfind-1054-confluence-set-up-over-provisioning.invite-link-fetch-error",
    CONFLUENCE_SETUP_OVER_SITE_PROVISIONING_ONBOARDING_RESPONSE_RECEIVED:
        "cfind-1054-confluence-set-up-over-provisioning.onboarding-response-received",
    CONFLUENCE_SETUP_OVER_SITE_PROVISIONING_ONBOARDING_RESPONSE_MISSING:
        "cfind-1054-confluence-set-up-over-provisioning.onboarding-response-missing",
    CONFLUENCE_SETUP_OVER_SITE_PROVISIONING_ONBOARDING_RESPONSE_ERROR:
        "cfind-1054-confluence-set-up-over-provisioning.onboarding-response-error"
} as const;

export type UfoEventName = (typeof UfoEventName)[keyof typeof UfoEventName];

// hello.atlassian.net/wiki/spaces/~lhunt/blog/2024/01/22/3243354933/How+Removing+and+Replacing+TypeScript+Enums+improves+Code
export const UfoExperienceStatus = {
    SUCCEEDED: "SUCCEEDED",
    ABORTED: "ABORTED"
} as const;

export type UfoExperienceStatus =
    (typeof UfoExperienceStatus)[keyof typeof UfoExperienceStatus];

export const UfoInteractionType = {
    PAGE_LOAD: "page-load",
    PRESS: "press",
    TYPING: "typing",
    TRANSITION: "transition",
    CUSTOM: "custom"
} as const;

export type UfoInteractionType =
    (typeof UfoInteractionType)[keyof typeof UfoInteractionType];

export type UfoLabelStack = { name: string }[];
